<a href="https://bviotmanager.azurewebsites.net?Caller=http://www.buonevacanze.org" target="_top">
    <p class="tab blink pull-right">{{FlashMessage}}</p>
</a>